import { render, staticRenderFns } from "./PageModelList.vue?vue&type=template&id=dfb032d4"
import script from "./PageModelList.vue?vue&type=script&lang=js"
export * from "./PageModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports